// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Comment-module--bx--text-truncate--end--scvc4";
export var bxTextTruncateFront = "Comment-module--bx--text-truncate--front--SvLBS";
export var container = "Comment-module--container--ugbNj";
export var fadeout = "Comment-module--fadeout--T2Tlv";
export var focused = "Comment-module--focused--9wd96";
export var textarea = "Comment-module--textarea--IvQgx";